import { render, staticRenderFns } from "./common-details.vue?vue&type=template&id=276ee380&scoped=true&"
import script from "./common-details.vue?vue&type=script&lang=js&"
export * from "./common-details.vue?vue&type=script&lang=js&"
import style0 from "./common-details.vue?vue&type=style&index=0&id=276ee380&lang=scss&scoped=true&"
import style1 from "./common-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ee380",
  null
  
)

export default component.exports